module.exports = __webpack_public_path__ + "img/indicators-white.0cd55074.svg";